import React from 'react';
import classNames from 'classnames';
import '../styles/index.scss';
var defaultProps = {
  label: '',
  size: '',
  brand: 'law',
  variant: 'primary',
  onClick: function onClick() {},
  disabled: false
};
/**
 * Button React Component
 *
 * @param  {string} label => The button label
 * @param  {string} brand => The brand the button should be styled for
 * @param  {string} variant => the button variant, at the moment we only support primary & secondary
 * @param  {functionCallback} onClick => function reference used when the button gets clicked
 * @param  {boolean} disabled => represent if the button is disabled or not
 */
var Button = function Button(_ref) {
  var label = _ref.label,
    brand = _ref.brand,
    variant = _ref.variant,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    size = _ref.size;
  var buttonSizing = '';
  switch (size) {
    case 'sm':
      buttonSizing = 'btn-sm';
      break;
    case 'lg':
      buttonSizing = 'btn-lg';
      break;
    default:
      buttonSizing = 'btn';
      break;
  }
  var buttonTheme = variant.toLowerCase() === 'secondary' ? 'btn-secondary' : 'btn-primary';
  var buttonStyling = classNames(buttonSizing, buttonTheme);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "btn-container",
    className: brand + " cms"
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "button",
    className: buttonStyling,
    type: "button",
    onClick: onClick,
    disabled: disabled
  }, label));
};
Button.defaultProps = defaultProps;
export { Button };